export default "__VITE_ASSET__BVXDQEJw__"